
export const PARTNERS_BALANCE_TYPES = {
  CREDITOR: 1,
  DEBTOR: 2,
};
